import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { getCourses, getExamsByCourse } from './services/db';

function preventDefault(event) {
  event.preventDefault();
}

export default function Orders() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [examEnabled, setExamEnabled] = useState(null);

  useEffect(() => {
    let mounted = true;

    const loadExams = async () => {
      try {
        const courses = await getCourses();
        if (!courses.length) return;

        const firstCourse = courses[0];
        const exams = await getExamsByCourse(firstCourse.id);

        if (!mounted) return;
        setRows(
          exams.map((exam) => ({
            id: exam.id,
            courseId: firstCourse.id,
            course: firstCourse.name,
            exam: exam.name,
            description: `Preguntas: ${Object.keys(exam.questions || {}).length}`,
          })),
        );
      } catch (error) {
        console.error('Error cargando exámenes', error);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    loadExams();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <React.Fragment>
      <Table style={{ marginTop: 80 }} size="small">
        <TableHead>
          <TableRow>
            {/* <TableCell>Carrera</TableCell> */}
            <TableCell>Curso</TableCell>
            <TableCell>Examen</TableCell>
            <TableCell>Descripción</TableCell>
            <TableCell align="right"></TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow style={{ marginTop: 50 }} key={row.id}>
              <TableCell>
                <Typography color={"#616161"} variant={"subtitle2"}>
                  {row.course}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color={"#616161"} variant={"subtitle2"}>
                  {row.exam}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color={"#616161"} variant={"subtitle2"}>
                  {row.description}
                </Typography>
              </TableCell>
              {/* <TableCell>
                <Typography color={"#616161"} variant={"subtitle2"}>
                  {row.turno}
                </Typography>
              </TableCell> */}
              <TableCell align="right">
                {
                  <Button
                    type="submit"
                    style={{ color: "#fff", backgroundColor: "#009efd" }}
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    onClick={async () => {
                      let checkE = await global.checkExam(row.id, row.courseId);
                      if(checkE){
                        alert('Este examen SI requiere Klarway')
                      }else{
                        alert('Este examen NO requiere Klarway')
                      }
                    }}
                  >
                    Status
                  </Button>
                }
              </TableCell>
              <TableCell align="right">
                {
                  <Button
                    type="submit"
                    style={{ color: "#fff", backgroundColor: "#009efd" }}
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    onClick={async () => {
                        let changedE = await global.changeActivationExam(row.id, row.courseId, row.exam, row.course);
                        console.log(changedE)
                    }}
                  >
                    Activar /Desactivar
                  </Button>
                }
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </React.Fragment>
  );
}
